<template>
	<div class="sale-statistic">
		<!-- 导航 -->
		<headerTemplate title="销售统计"></headerTemplate>

		<!-- <van-nav-bar
		  title="销售统计"
		  left-text="返回"
		  left-arrow
		  @click-left="goBack"
		/> -->
		<!-- 搜索div -->
		<div class="filter">
			<van-dropdown-menu>
				<van-dropdown-item v-model="typeVal" ref="日期" :options="option1" @change="onConfirmSearch" />
				<van-dropdown-item title="下单时间" ref="下单时间">
					<van-cell title="选择日期区间" :value="date" @click="showCalender = true" />
					<van-calendar v-model="showCalender" type="range" :min-date="minDate" @confirm="onConfirm" />
					<div style="padding: 5px 16px;">
						<van-button type="danger" block round @click="onConfirmSearch">确认</van-button>
					</div>
				</van-dropdown-item>
			</van-dropdown-menu>
		</div>
		<!-- <div class="filter">
			<div style="display: flex; justify-content: space-between; align-items: center; background-color: white; padding: 0 20px;">
				<span>统计类别</span>
				<van-dropdown-menu>
					<van-dropdown-item v-model="typeVal" :options="option1" />
				</van-dropdown-menu>
			</div>
			<div>
				<van-cell title="选择日期区间" :value="date" @click="showCalender = true" />
				<van-calendar v-model="showCalender" type="range" :min-date="minDate" @confirm="onConfirm" />
			</div>
			<van-button style="width: 50px; margin: 10px 0 0 20px;" type="info" size="mini" @click="search">搜索</van-button>
		</div> -->
		<!-- 表格展示 -->
		<div class="show-product">
			<div class="show-nav">
				<span class="nav-item">销售单数</span>
				<span class="nav-item">销售金额</span>
				<span class="nav-item">退货单数</span>
				<span class="nav-item">统计时间</span>
				<span class="nav-item">详情</span>
			</div>
			<div class="show-content" v-for="(item, i) in statisticList" :key="i">
				<span class="content-item">{{item.seller_count}}3</span>
				<span class="content-item">{{item.seller_amount}}冲牙器</span>
				<span class="content-item">{{item.refund_count}}</span>
				<span class="content-item">{{item.times}}</span>
				<span class="content-item">
					<van-button type="info" size="mini" @click="openStatisticInfo">详情</van-button>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	import { getSalesIndex } from '../../../api/sale'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	export default {
		name: 'SaleStatistic',
		components: {
			headerTemplate
		},
		data() {
			return {
				typeVal: '',
				option1: [
					{ text: '全部', value: '' },
					{ text: '天', value: 'days' },
					{ text: '周', value: 'weeks' },
					{ text: '月', value: 'months' },
					{ text: '季度', value: 'quarter' },
					{ text: '年', value: 'years' }
				],
				// 日历显示最小日期
				minDate: new Date(2020, 0, 1),
				// 日期区间
				date: '',
				// 开始日期
				sDate: '',
				// 结束日期
				eDate: '',
				// 是否展示日历
				showCalender: false,
				// 搜索出的销售统计内容
				statisticList: []
			}
		},
		methods: {
			// 返回上一页
			goBack() {
				this.$router.go(-1)
			},
			// 打开详情页
			openStatisticInfo() {
				this.$router.push({
					name: 'StatisticInfo',
					params: {
						statisticList: this.statisticList
					}
				})
			},
			// 日期构造
			formatDate(date) {
				if ((date.getMonth() + 1) < 10 && date.getDate() < 10) {
					return `${date.getFullYear()}-0${date.getMonth() + 1}-0${date.getDate()}`;
				}
				if ((date.getMonth() + 1) < 10 && date.getDate() >= 10) {
					return `${date.getFullYear()}-0${date.getMonth() + 1}-${date.getDate()}`;
				}
				if ((date.getMonth() + 1) >= 10 && date.getDate() < 10) {
					return `${date.getFullYear()}-${date.getMonth() + 1}-0${date.getDate()}`;
				}
				return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			},
			// 选择日期
			onConfirm(date) {
				const [start, end] = date;
				this.showCalender = false;
				this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
				this.sDate = `${this.formatDate(start)}`
				this.eDate = `${this.formatDate(end)}`
			},
			// 搜索
			onConfirmSearch() {
				getSalesIndex(this.typeVal, this.sDate, this.eDate).then(res => {
					this.statisticList = res.result
					this.$refs['日期'].toggle(false)
					this.$refs['下单时间'].toggle(false)
				}).catch(error => {
					// 
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.sale-statistic {
		font-size: 14px;

		.filter {
			display: flex;
			flex-direction: column;
		}

		.show-product {
			background-color: #fff;
			box-shadow: 0 0 5px #EEEEEE;
			margin: 10px;
			border-radius: 10px;
			padding: 10px;
		}

		.show-nav {
			display: flex;
			margin-bottom: 10px;

			.nav-item {
				flex: 1;
				display: flex;
				justify-content: center;
			}
		}

		.show-content {
			display: flex;

			.content-item {
				flex: 1;
				display: flex;
				justify-content: center;
				flex-shrink: 0;
			}

			.content-item   ::v-deep.van-button {
				width: 50px;
			}
		}

		.show-content:not(:last-child) {
			margin-bottom: 10px;
		}
	}

	/* .sale-statistic   ::v-deep.van-nav-bar {
		background-color: #e93b3d;
		color: white;

		.van-icon-arrow-left,
		.van-nav-bar__text,
		.van-nav-bar__title {
			color: white;
		}
	} */
</style>